import { HttpClient } from '../httpClient';
import TaskTypesResponse from '../responses/tasktypesResponse';
import TaskTypeResponse from '../responses/tasktypeResponse';
import TaskTypeRequest from '../requests/tasktypeRequest';
import { BaseResponse } from '../responses/baseResponse';

const httpClient = new HttpClient();

export const getAllTaskTypes = async () =>{
  return getTaskTypes();
}

export const getTaskTypes = async (disciplineId?:number, studentStatusId?:number, entryTypeId?:number) => {
  let query = "?";
  query += (typeof disciplineId === "number") ? `disciplineId=${disciplineId}&` : ""; 
  query += (typeof studentStatusId === "number") ? `studentStatusId=${studentStatusId}&` : "";
  query += (typeof entryTypeId === "number") ?  `entryTypeId=${entryTypeId}` : "";
  
  return httpClient.get<TaskTypesResponse>({
    url: '/v1/Tasktypes' + query,
    requiresToken: true,
  });
};

export const getTaskType = async (tasktypeId: number) => {
  return httpClient.get<TaskTypeResponse>({
    url: `/v1/Tasktypes/${tasktypeId}`,
    requiresToken: true,
  });
};

export const createTaskType = async (tasktyperequest: TaskTypeRequest) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/admin/tasktypes',
    payload: tasktyperequest,
    requiresToken: true,
  });
};

export const updateTaskType = async (taskTypeId: number, tasktyperequest: TaskTypeRequest) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/tasktypes/${taskTypeId}`,
    payload: tasktyperequest,
    requiresToken: true,
  });
};

export const deleteTaskType = async (tasktypeId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/tasktypes/${tasktypeId}`,
    requiresToken: true,
  });
};
